module.exports = "../../../../platform/assets/pageMainIcon/youth_yewuchulilei5.svg";